// Constants.
import { GET_MENU_ITEMS } from '../actions/menuActions';

const initialState = {
  items: []
};

export const menuItems = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_ITEMS:
      return {
        ...state,
        items: action.menuItemsPayload
      }
    default:
      return state
  }
}
